import { Navigate, Outlet } from "react-router-dom";

import { useSessaoStore } from "../lib/auth/store";

/*
 * Guard de rota reativo (FE-1 CP2 — ADR 0026 §Decisão D / Roteamento).
 *
 * Usa o HOOK REATIVO do zustand (não o getter fora-de-React): assim que o store
 * perde o access token (logout, 401 no refresh, reuse-detection), o componente
 * re-renderiza e expulsa para `/login`. Análogo ao guard discutido no CP-C.
 *
 * NAVEGAÇÃO: só path puro ("/login"), via `<Navigate replace />` — nenhum token
 * vai para rota/query/state. A rota `/login` é PÚBLICA (não passa por aqui).
 */
export function RotaProtegida(): JSX.Element {
  // Hook reativo: a seleção é o booleano de presença do token (não o token).
  const autenticado = useSessaoStore((s) => s.accessToken !== null);

  if (!autenticado) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
